
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/tennispointapp",
      function () {
        return require("private-next-pages/cases/tennispointapp/index.tsx");
      }
    ]);
  